import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import CharitiesPage from "./charities-page";
import CharityCreatePage from "./charity-create-page";
import CharityEditPage from "./charity-edit-page";
 

export default (
  <Route path="charities">
    <Route
      index
      element={
        <Protected
          path="/admin/charities"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <CharitiesPage />
        </Protected>
      }
    />

    <Route
      path="create"
      element={
        <Protected
          path="/admin/charities/create"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <CharityCreatePage />
        </Protected>
      }
    />
    
    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/charities/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <CharityEditPage />
        </Protected>
      }
    />  
  </Route>
);
